/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { type ReactNode } from "react";

/**
 * The registry collection table: wide content scrolls inside its own container, the page never
 * scrolls horizontally. Rows are the caller's; this owns only the frame and header styling.
 */
export function RegistryTable({
  headers,
  children,
}: {
  headers: string[];
  children: ReactNode;
}) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full min-w-[36rem] text-left text-sm">
        <thead>
          <tr>
            {headers.map((header) => (
              <th
                key={header}
                className="border-b border-border pb-2 pr-4 text-[11px] font-semibold uppercase tracking-[0.13em] text-text-tertiary"
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-border/50">{children}</tbody>
      </table>
    </div>
  );
}
